var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#009A7E",
    height: 1.6,
    id: "svg_2",
    rx: 0.4,
    stroke: "#231E1E",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    transform: "matrix(0.963199 -0.978085 0.972575 0.968698 1.96761 11.7797)",
    width: 4.4,
    x: 2.44,
    y: -2.62
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#231E1E",
    id: "svg_3",
    points: "1.766476560384035,6.859811628237367 1.388698149472475,8.808472478762269 3.3225974328815937,8.409727895632386 ",
    stroke: "#231E1E",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 1.6,
    id: "svg_4",
    rx: 0.2,
    stroke: "#231E1E",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    transform: "matrix(0.963199 -0.978085 0.972575 0.968698 7.3483 6.28941)",
    width: 1.2,
    x: 1.24,
    y: -2.61
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarResearchIcon);
export default __webpack_public_path__ + "static/media/SideBarResearchIcon.a082cc21ea1f3121c75c44fdda245cd3.svg";
export { ForwardRef as ReactComponent };